import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TaskErrorCard = () => {
  return /*#__PURE__*/_jsx(CardWrapper, {
    "data-card-locator": "task-load-error",
    "data-test-id": "user-guide-load-error-card",
    children: /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(View, {
          children: /*#__PURE__*/_jsx(Illustration, {
            height: 64,
            name: "errors/general"
          })
        }), /*#__PURE__*/_jsx(View, {
          paddingInline: "500",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h3",
            marginBlockEnd: "0",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "setup-guide-components.checklist.error.setupTaskError.title"
            })
          })
        })]
      })
    })
  });
};
export default TaskErrorCard;